import { json2csv } from "json-2-csv"

import { SUPPORT_REFER } from "../errors/errorMessages"
import { snackbar } from "../utils/general/generalUtils"

interface IDownloadJson {
    downloadJson: (json: Record<string, unknown>, filename: string) => void
}

/**
 * Provides functionality required to download json payloads
 * @returns {IDownloadJson} - helper with JSON download function
 */

const useDownloadJson = (): IDownloadJson => {
    /**
     * Allows user to download data into JSON form. Please use sparingly with
     * appropriate RBAC in place.
     * @param {Record<string, unknown>} json - object to be downloaded.
     * @param {string} filename - filename
     */
    const downloadJson = <T>(
        json: Record<string, T>,
        filename: string
    ): void => {
        try {
            const arrayJson = json.results
            const csv = json2csv(arrayJson as object[])

            const jsonString = `data:text/csv;chatset=utf-8,${encodeURIComponent(
                csv
            )}`
            const filenameFull = `${filename}.csv`
            const downloadLink = document.createElement("a")
            downloadLink.href = jsonString
            downloadLink.download = filenameFull
            downloadLink.click()
        } catch {
            snackbar(
                `Something went wrong whilst trying to download your data. ${SUPPORT_REFER}`,
                "warning"
            )
        }
    }

    return {
        downloadJson,
    }
}

export default useDownloadJson
